import { MenuTitleDescriptionModel } from './menu-title-description.model';
import { MenuItemBulletListModel } from './menu-item-bullet-list.model';

export class MenuItemModel {
  id: number;
  menu_section_id: number;
  menu_category_id: number;
  name: string;
  description: string;
  image_url: string;
  email: string;
  phone: string;
  youtube: string;
  web_site_title: string;
  web_site_url: string;
  virtual_tour_url: string;
  dress_code: string;
  location_description: string;
  activate_map_location: boolean;
  map_location: string;
  map_location_point_icon: string;
  show_title_and_description: boolean;
  show_bullet_list: boolean;
  show_dress_code: boolean;
  show_location_description: boolean;
  show_email: boolean;
  show_phone_number: boolean;
  show_youtube: boolean;
  show_web_site: boolean;
  show_virtual_tour: boolean;
  booking_system: string;
  external_booking_engine_url: string;
  emails_of_the_staff: string;
  see_more: boolean;
  see_more_menu_section_id: number;
  hotel_id: number;
  show_follow: boolean;
  show_booking_date: boolean;
  show_loyalty_point: boolean;
  loyalty_min_point: number;
  loyalty_max_point: number;
  show_survey: boolean;
  survey_title: string;
  survey_description: string;
  priority: number;
  adult_count: number;
  child_count: number;
  baby_count: number;
  url_links: string;
  url_title: string;
  auto_approve: boolean;
  photos: string;
  menu_item_title_and_descriptions: MenuTitleDescriptionModel[];
  menu_item_bullet_lists: MenuItemBulletListModel[];
  room_capacity: number;
  min_accomodation: number;
  bed_count: number;
  number_of_bedroom: number;
  bath_count: number;
  field: number;
  base_price: number;
  fix_menu: boolean;
  active: boolean;
  show_on_home_page: boolean;
  location_control_mandatory: boolean;
  home_page_priority: number;
  maximum_reservation: number;
  reservation_restriction_type: string;
  reservation_restriction_value: number;
  user_ids_for_notifications: string;
  show_date_range: boolean;
  start_date: Date;
  end_date: Date;
  accommodation_period: number;
  group_name: string;
  show_main_catalog_group: boolean;

  activate_delivery_range: boolean;
  delivery_range: number;
  activate_delivery_post_codes: boolean;
  delivery_post_codes: string;
  activate_excluded_post_codes: boolean;
  excluded_post_codes: string;
  activate_free_delivery_over_amount: boolean;
  free_delivery_over_amount: number;
  delivery_price_distance_range_1: number;
  delivery_price_type_1: 'fix' | 'distance';
  delivery_unit_price_1: number;
  delivery_price_distance_range_2: number;
  delivery_price_type_2: 'fix' | 'distance';
  delivery_unit_price_2: number;
  delivery_price_distance_range_3: number;
  delivery_price_type_3: 'fix' | 'distance';
  delivery_unit_price_3: number;

  order_system: boolean;
  show_price: boolean;
  show_comment: boolean;
  show_order_info: boolean;
  only_table: boolean;

  constructor(
    id = 0,
    menu_section_id = 0,
    menu_category_id = 0,
    name = '',
    description = '',
    image_url = '',
    email = '',
    phone = '',
    youtube = '',
    web_site_title = '',
    web_site_url = '',
    virtual_tour_url = '',
    dress_code = '',
    location_description = '',
    activate_map_location = false,
    map_location = '',
    map_location_point_icon = '',
    show_title_and_description = false,
    show_bullet_list = false,
    show_dress_code = false,
    show_location_description = false,
    show_email = false,
    show_phone_number = false,
    show_youtube = false,
    show_web_site = false,
    show_virtual_tour = false,
    booking_system = 'only timetable',
    external_booking_engine_url = '',
    emails_of_the_staff = '',
    see_more = false,
    see_more_menu_section_id = 0,
    hotel_id = 0,
    show_follow = false,
    show_booking_date = false,
    show_loyalty_point = false,
    loyalty_min_point = 0,
    loyalty_max_point = 0,
    show_survey = false,
    survey_title = '',
    survey_description = '',
    priority = 0,
    adult_count = 0,
    child_count = 0,
    baby_count = 0,
    url_links = '',
    url_title = '',
    auto_approve = false,
    menu_item_title_and_descriptions = [],
    menu_item_bullet_lists = [],
    room_capacity = 0,
    min_accomodation = 0,
    bed_count = 0,
    number_of_bedroom = 0,
    bath_count = 0,
    field = 0,
    base_price = 0,
    fix_menu = false,
    active = true,
    show_on_home_page = false,
    location_control_mandatory = false,
    maximum_reservation = 0,
    reservation_restriction_type = '',
    reservation_restriction_value = 0,
    show_date_range = false,
    start_date = new Date(),
    end_date = new Date(),
    accommodation_period = 0,
    group_name = '',
    show_main_catalog_group = false) {
    this.id = id;
    this.menu_section_id = menu_section_id;
    this.menu_category_id = menu_category_id;
    this.name = name;
    this.description = description;
    this.image_url = image_url;
    this.email = email;
    this.phone = phone;
    this.youtube = youtube;
    this.web_site_title = web_site_title;
    this.web_site_url = web_site_url;
    this.virtual_tour_url = virtual_tour_url;
    this.dress_code = dress_code;
    this.location_description = location_description;
    this.activate_map_location = activate_map_location;
    this.map_location = map_location;
    this.map_location_point_icon = map_location_point_icon;
    this.show_title_and_description = show_title_and_description;
    this.show_bullet_list = show_bullet_list;
    this.show_dress_code = show_dress_code;
    this.show_location_description = show_location_description;
    this.show_email = show_email;
    this.show_phone_number = show_phone_number;
    this.show_youtube = show_youtube;
    this.show_web_site = show_web_site;
    this.show_virtual_tour = show_virtual_tour;
    this.booking_system = booking_system;
    this.external_booking_engine_url = external_booking_engine_url;
    this.emails_of_the_staff = emails_of_the_staff;
    this.see_more = see_more;
    this.see_more_menu_section_id = see_more_menu_section_id;
    this.hotel_id = hotel_id;
    this.show_follow = show_follow;
    this.show_booking_date = show_booking_date;
    this.show_loyalty_point = show_loyalty_point;
    this.loyalty_min_point = loyalty_min_point;
    this.loyalty_max_point = loyalty_max_point;
    this.show_survey = show_survey;
    this.survey_title = survey_title;
    this.survey_description = survey_description;
    this.priority = priority;
    this.adult_count = adult_count;
    this.child_count = child_count;
    this.baby_count = baby_count;
    this.url_links = url_links;
    this.url_title = url_title;
    this.auto_approve = auto_approve;
    this.room_capacity = room_capacity;
    this.min_accomodation = min_accomodation;
    this.bed_count = bed_count;
    this.number_of_bedroom = number_of_bedroom;
    this.bath_count = bath_count;
    this.field = field;
    this.base_price = base_price;
    this.fix_menu = fix_menu;
    this.active = active;
    this.show_on_home_page = show_on_home_page;
    this.location_control_mandatory = location_control_mandatory;
    this.maximum_reservation = maximum_reservation;
    this.reservation_restriction_type = reservation_restriction_type;
    this.reservation_restriction_value = reservation_restriction_value;
    this.show_date_range = show_date_range;
    this.start_date = start_date;
    this.end_date = end_date;
    this.accommodation_period = accommodation_period;
    this.group_name = group_name;
    this.show_main_catalog_group = show_main_catalog_group;
  }
}
